module.exports = __webpack_public_path__ + "img/1-1.684cb41d.svg";